import {
    ApolloClient,
    InMemoryCache,
    HttpLink,
    ApolloLink,
} from "@apollo/client";
import { createCommonHeadersMiddleware } from "./services/middleware/commonHeaders.middleware";

const uri = process.env.REACT_APP_AUTH_BASE_GRAPHQL_URI || ''
const httpLink = new HttpLink({
    uri: uri,
});

const authClientService = new ApolloClient({
    cache: new InMemoryCache(),
    link: ApolloLink.from([
        createCommonHeadersMiddleware(),
        httpLink,
    ]),
    defaultOptions: {
        watchQuery: {
            fetchPolicy: "network-only",
        },
        query: {
            fetchPolicy: "network-only",
        },
    },
});

export default authClientService;
